import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=60623f36&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=60623f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60623f36",
  null
  
)

export default component.exports